import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
 // Adjust the path to your CSS file


function ProjectDetails() {
  // State to store project details
  const [project, setProject] = useState(null);

  // Access the project ID from the URL
  const { id } = useParams();

  // Simulated project data (replace with your actual project data)
  const projectData = {
    '1': {
      title: 'Project 1',
      description: 'Description of Project 1...',
      // Add more details as needed
    },
    '2': {
      title: 'Project 2',
      description: 'Description of Project 2...',
      // Add more details as needed
    },
		'3': {
      title: 'Project 1',
      description: 'Description of Project 1...',
      // Add more details as needed
    },
    '4': {
      title: 'Project 2',
      description: 'Description of Project 2...',
      // Add more details as needed
    },
    // Add more project data as needed
  };

  useEffect(() => {
    // Fetch the project details based on the ID
    const fetchProjectDetails = () => {
      // Simulated API request (replace with actual data fetching)
      setTimeout(() => {
        if (projectData[id]) {
          setProject(projectData[id]);
        } else {
          // Handle project not found
          setProject(null);
        }
      }, 500); // Simulated delay for demonstration
    };

    fetchProjectDetails();
  }, [id]);

  return (
    <div className="container mx-auto mt-8">
      {project ? (
        <div>
          <h1 className="text-3xl font-semibold mb-4">{project.title}</h1>
          <p className="text-gray-700">{project.description}</p>
          {/* Add more project details here */}
        </div>
      ) : (
        <p className="text-red-500">Project not found.</p>
      )}
    </div>
  );
}

export default ProjectDetails;
